import type { BorderStyleModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useSelectedElement } from "@/features/react-editor/components/modifiers/store/ModifiersStoreContext";
import { useOverridableState } from "replo-runtime/shared/hooks/useOverridableState";

import BorderStyleSelector from "./BorderStyleSelector";

interface BorderStyleModifierProps {
  onChange: (modifier: BorderStyleModifierValue) => void;
}

const BorderStyleModifier: React.FC<BorderStyleModifierProps> = ({
  onChange,
}) => {
  const selectedElement = useSelectedElement();

  const extractedStyle = React.useMemo(() => {
    return selectedElement?.styleOverrides?.borderTopStyle ?? "none";
  }, [selectedElement]);

  const [currentStyle, setCurrentStyle] = useOverridableState(
    extractedStyle,
    React.useCallback(
      (style: string | null) => {
        const modifier: BorderStyleModifierValue = {
          type: "borderStyle",
          value: style as "solid" | "dashed" | "dotted" | "double",
        };
        onChange(modifier);
      },
      [onChange],
    ),
  );

  const handleStyleChange = React.useCallback(
    (style: string | null) => {
      setCurrentStyle(style ?? "none");
    },
    [setCurrentStyle],
  );

  return (
    <BorderStyleSelector
      borderStyle={currentStyle}
      onSelect={handleStyleChange}
    />
  );
};

export default BorderStyleModifier;
